export default "__VITE_ASSET__DNpiqpWi__"